import { Component, Input } from '@angular/core';
import { CustomerNoteService } from '../../../../services/customer-note.service';

@Component({
  selector: 'app-components-notes-summary',
  templateUrl: './notes-summary.component.html'
})
export class NotesSummaryComponent {
  @Input() customerId: number;
  loading = false;
  isCollapsed = true;
  summaryOfNotes: string;
  reviewsActive = false;

  constructor(private customerNoteService: CustomerNoteService) { }

  showSummary(): void {
    this.isCollapsed = !this.isCollapsed;
    if (!this.isCollapsed && !this.summaryOfNotes) {
      this.getSummary();
    }
  }

  getSummary(forceNew = false): void {
    this.loading = true;
    this.customerNoteService.getSummary(this.customerId, forceNew)
      .subscribe({
        next: (data) => {
          this.summaryOfNotes = data.Result;
        },
        error: (err) => {
          this.loading = false;
          toastr.error('Error occurred while generating summary');
        },
        complete: () => {
          this.loading = false;
        }
      });
  }
}
